<template>
  <div v-if="statement" class="flex gap-x-4">
    <Input
      v-model="statement.data.value"
      :error="errors?.value"
      :disabled="disabled"
      class="grow mt-4"
    />
  </div>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import Input from '@utils/inputs/Input.vue';
import type { FilterPrototype, LogicStatement, MaybeHydra } from '@/entities/Entities';

interface Props {
  modelValue?: MaybeHydra<
    LogicStatement<{
      value: string;
    }>
    >;
  prototype: FilterPrototype<
    { value: string },
    Record<string, never>
    >;
  errors?: object;
  disabled?: boolean;
}

const props = defineProps<Props>();

const { t } = useI18n();

const emit = defineEmits(['update:modelValue']);
const statement = useVModel(props, 'modelValue', emit, { passive: true });
</script>

<style lang="scss" scoped></style>
